"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveFrontendTimezone = resolveFrontendTimezone;
/**
 * 前端展业时区解析
 *
 * 前端无法使用 @ark/env（其依赖 @futu/appinfo，属后端/Node 专用），
 * 因此这里从宿主注入的 window._params.siteId 解析展业时区。
 * 地区/时区映射统一复用 @ark/utils，不重复维护。
 *
 * 取不到（缺失 / 未知 siteId / 无对应展业时区）时直接抛错，
 * 不做默认时区兜底，以便及时暴露宿主未正确注入 siteId 的问题。
 */
const utils_1 = require("@ark/utils");
/**
 * 解析前端当前展业时区。
 *
 * @throws 当 window._params.siteId 缺失或无法映射为展业时区时抛错
 */
function resolveFrontendTimezone() {
    const location = (0, utils_1.resolveFrontendLocation)();
    if (!location) {
        throw new Error(`[@ark/dayjs/frontend] 无法从 window._params.siteId 解析展业时区，siteId=${String((0, utils_1.getFrontendSiteId)())}`);
    }
    return utils_1.LOCATION_TIMEZONE_MAP[location];
}
